import { Search } from 'lucide-react';
import { SkeletonBox } from '@/shared/ui';

type SearchNaverResultItemSkeletonProps = {
	titleWidthClassName?: string;
};

const SearchNaverResultItemSkeleton = ({
	titleWidthClassName = 'w-48',
}: SearchNaverResultItemSkeletonProps) => {
	return (
		<li className="flex list-none items-center gap-2 px-5 py-3">
			<Search className="size-4 shrink-0 text-mantang-gray-500" />
			<SkeletonBox className={`h-5 ${titleWidthClassName}`} />
		</li>
	);
};

export default SearchNaverResultItemSkeleton;
